import { SET_SUBMISSION_TYPE } from '../types'

export const setSubmission = (payload) => ({
  type: SET_SUBMISSION_TYPE,
  payload,
})
